"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import 'react';
import styles from './Navigation.module.scss.mjs';
import clsx from 'clsx';
import { ClearPropsContext } from '../ClearPropsContext/ClearPropsContext.mjs';
import '../../lib/propsContext/propsContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { TunnelProvider, TunnelExit } from '@mittwald/react-tunnel';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';

const Navigation = flowComponent("Navigation", (props) => {
  const { className, children, ref, ...rest } = props;
  const rootClassName = clsx(styles.navigation, className);
  const propsContext = {
    Link: {
      wrapWith: /* @__PURE__ */ jsx("li", {}),
      className: styles.item,
      unstyled: true,
      Text: {
        className: styles.text
      },
      Icon: {
        className: styles.icon
      },
      tunnelId: "links"
    }
  };
  return /* @__PURE__ */ jsx(ClearPropsContext, { children: /* @__PURE__ */ jsx(TunnelProvider, { children: /* @__PURE__ */ jsx("nav", { className: rootClassName, role: "navigation", ...rest, ref, children: /* @__PURE__ */ jsxs(PropsContextProvider, { props: propsContext, mergeInParentContext: true, children: [
    /* @__PURE__ */ jsx("ul", { children: /* @__PURE__ */ jsx(TunnelExit, { id: "links" }) }),
    children
  ] }) }) }) });
});

export { Navigation, Navigation as default };
//# sourceMappingURL=Navigation.mjs.map
